import ky from 'ky'

const isDev = process.env.REACT_APP_ENVIRONMENT === 'dev'

/**
 * axiosの代替としてkyを導入(axiosに脆弱性が発覚したため)
 */
export const kyApi = (token: string = '') => {
  if (isDev) {
    return ky.create({
      prefixUrl: `${process.env.REACT_APP_SERVER_URL}`,
      headers: {
        Authorization: `${token}`, // トークン認証
      },
      timeout: false, // タイムアウトは設定しない
    })
  }
  return ky.create({
    headers: {
      Authorization: `${token}`, // トークン認証
    },
    timeout: false, // タイムアウトは設定しない
  })
}
